__turbopack_context__.v({
  "loader": "styles-module__V5YuFa__loader",
  "loaderContainer": "styles-module__V5YuFa__loaderContainer",
  "spin": "styles-module__V5YuFa__spin",
});
